<form [formGroup]="formGroup" class="formGroup" (ngSubmit)="save()">
  <mat-form-field appearance="outline">
    <mat-label>Штрихкод</mat-label>
    <input matInput placeholder="Штрихкод" formControlName="barcode" />
    <mat-icon matSuffix>qr_code_2</mat-icon>
  </mat-form-field>
  <button mat-flat-button color="primary">
    Сохранить
    <mat-icon>save</mat-icon>
  </button>
</form>
